<template>
  <v-skeleton-loader class="mx-auto" max-height="200px" max-width="200px" type="image">
    <v-img
      v-if="imageLoaded"
      :src="imageURL"
      @error="onImgError"
      @load="onImgLoad"
      cover
      style="border-radius: 4px"
    >
      <template v-slot:placeholder>
        <v-skeleton-loader class="mx-auto" max-width="200" type="image"></v-skeleton-loader>
      </template>
    </v-img>
    <v-skeleton-loader v-else boilerplate type="image"></v-skeleton-loader>
  </v-skeleton-loader>
</template>

<script>
export default {
  props: {
    group: {}
  },
  data() {
    return {
      imageLoaded: true
    };
  },
  computed: {
    imageURL() {
      return (
        this.$axios.defaults.prodImagesURL +
        "pg_" +
        this.group.group_no +
        ".png"
      );
    }
  },

  methods: {
    onImgError() {
      this.imageLoaded = false;
      return false;
    },
    onImgLoad() {
      console.log("-- Image Load Success");
      this.imageLoaded = true;
      return;
    }
  }
};
</script>

<style lang="sass" scoped>
</style>